import { render, staticRenderFns } from "./HeroText.vue?vue&type=template&id=64f0cc6e&"
import script from "./HeroText.vue?vue&type=script&lang=js&"
export * from "./HeroText.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports